const SYM = { INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "AED ", THB: "฿", JPY: "¥", CNY: "¥", WFC: "WFC " };

const fmt = (v) => Number(v).toLocaleString("en-IN", { maximumFractionDigits: v >= 1000 ? 0 : 2 });
const when = (ts) => (ts ? new Date(ts).toLocaleString("en-IN", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");

// "× 1.15 (Customs duty 10% + AIDC 5%, combined)" from the admin-configured calculation record.
export const adjustmentText = (calc) => {
  const parts = (calc?.components || []).filter(c => c.applied).map(c => `${c.name} ${c.pct}%`);
  return `× ${calc?.multiplier ?? "—"} (${parts.join(" + ") || "no adjustments"}${calc?.method ? `, ${calc.method}` : ""})`;
};

// One renderer for every market-rate surface (card, list row, pinned banner) — same validated record.
export const RatePrice = ({ row, detailed = false }) => {
  const cur = row.conv_currency || row.currency || "INR";
  const v = row.price_conv ?? row.price;
  const p = row.meta?.pricing || {};
  return (
    <div className="text-[11px]" data-testid={`rate-price-${row.id}`}>
      {v != null
        ? <div className="font-black text-stone-900 text-sm">{SYM[cur] || `${cur} `}{fmt(v)}<span className="text-[10px] text-stone-500 font-bold">{row.unit}</span></div>
        : <div className="font-black text-stone-500" data-testid={`rate-unavailable-${row.id}`}>Unavailable</div>}
      {row.price_10g != null && !row.conv_currency && <div className="text-[10px] text-stone-600">₹{fmt(row.price_10g)} / 10 g</div>}
      {row.meta?.label && <div className="text-[10px] text-stone-500 truncate">{row.meta.label}</div>}
      <div className="text-[9px] text-stone-400 truncate" data-testid={`rate-source-${row.id}`}>
        {row.meta?.source || "—"} · {when(row.meta?.updated_at)}
      </div>
      {detailed && row.category === "gold" && p.notice && (
        <div className="text-[10px] text-stone-600 mt-1 space-y-0.5" data-testid="rate-calc">
          <div>Spot ${p.xau_usd_per_oz ?? "—"}/oz × USD/INR {p.usd_inr ?? "—"} ÷ 31.1035 = ₹{p.international_inr_per_gram ?? "—"}/g</div>
          <div>{adjustmentText(p.calculation)} · 22K ₹{p.gold_22k_per_gram ?? "—"} · 18K ₹{p.gold_18k_per_gram ?? "—"}</div>
          <div className="font-bold">{p.notice}</div>
        </div>
      )}
    </div>
  );
};
